export const API_ENDPOINTS = {
  bookingRequests: '/booking-requests',
  inspectionDetail: (id: string) => `/inspections/${id}`,
  inspectionPdf: (id: string) => `/inspections/${id}/pdf`,
  inspectionSync: (id: string) => `/inspections/sync/${id}`,
  bookingRequestsImport: '/booking-requests/import',
  bookingRequestsReplan: '/auto-plan',
  orders: '/orders',
  auth: {
    login: '/auth/login',
    logout: '/auth/logout',
    refresh: '/auth/refresh',
    me: '/auth/me',
  },
  planning: {
    list: '/planning',
    detail: (id: string) => `/planning/${id}`,
    create: '/planning',
    update: (id: string) => `/planning/${id}`,
    delete: (id: string) => `/planning/${id}`,
  },
  users: {
    list: '/users',
    detail: (id: string) => `/users/${id}`,
  },
  suppliers: '/orders/suppliers',
  factories: '/common/factories',
  cities: '/common/cities',
  departments: '/common/departments',
  controlPoints: '/meta/control-points',
  inspectionLevels: '/meta/inspection-levels',
  bookingStatuses: '/meta/booking-request-statuses',
  locations: '/meta/tenant-centres',
  myLocations: '/users/my-locations',
  defects: '/meta/defects',
  inspectionResults: '/meta/inspection-results',
  productCategories: '/common/product-categories',
  inspectorsManagement: {
    inspectors: '/inspector-management/inspectors',
    inspectorDetail: (id: string) => `/inspector-management/inspectors/${id}`,
  },
  publicHolidays: '/meta/holidays',
  autoplanConfig: '/meta/configurations/autoplan',
  customers: '/common/customers',
  divisions: '/meta/divisions',
} as const;
